import * as React from 'react';
import { Fragment, useState } from 'react';
import Refresh from '@material-ui/icons/Refresh';
import {
    Button,
    Confirm,
    useDeleteMany,
    useListContext,
    useNotify,
    useRefresh,
    useTranslate,
    useUnselectAll,
} from 'react-admin';
import { useApolloClient } from '@apollo/client'
import {
    RECOVER_EVENT,
} from './gql';

const BulkRecoverButtonAction = (props: any) => {
    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const { selectedIds } = props;
    const translate = useTranslate();
    const apolloClient = useApolloClient();
    const [loading, setLoading] = useState<Boolean>(false);
    const {
        resource,
    } = useListContext();
    const deleteMany = async () => {
        setLoading(true);
        const { data, errors } = await apolloClient.mutate({
            mutation: RECOVER_EVENT,
            variables: {
                list_event_id: selectedIds
            }
        });
        setLoading(false);        
        if (data.update_event.affected_rows > 0) {
            refresh();
            notify(translate('common.msg_restore'));
            unselectAll(resource);
        }
        if (errors) {
            notify(translate('common.msg_delete_fail'), 'warning')
        }
    }
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);

    const handleConfirm = async () => {
        await deleteMany();
        setOpen(false);
    };

    return (
        <Fragment>
            <Button label={translate('common.btn_recover')} onClick={handleClick} startIcon={<Refresh />} style={{ color: '#FF8C00' }} />
            <Confirm
                isOpen={open}
                loading={loading}
                title={translate('common.msg_title_recover')}
                content={translate('common.msg_recover_confirm')}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
};

export default BulkRecoverButtonAction;